import { render, staticRenderFns } from "./TaxToggle.vue?vue&type=template&id=79d11006"
import script from "./TaxToggle.vue?vue&type=script&lang=js"
export * from "./TaxToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports